import {
  Popover as ChakraPopover,
  IconButton,
  type IconButtonProps,
  Portal,
} from "@chakra-ui/react";
import { InfoIcon } from "lucide-react";
import * as React from "react";

type ToggleTipProps = ChakraPopover.RootProps & {
  showArrow?: boolean;
  portalled?: boolean;
  portalRef?: React.RefObject<HTMLElement | null>;
  content?: React.ReactNode;
  contentProps?: ChakraPopover.ContentProps;
};

export const ToggleTip = React.forwardRef<HTMLDivElement, ToggleTipProps>(
  function ToggleTip(props, ref) {
    const {
      showArrow,
      children,
      portalled = true,
      content,
      contentProps,
      portalRef,
      ...rest
    } = props;

    return (
      <ChakraPopover.Root
        {...rest}
        positioning={{ ...rest.positioning, gutter: 4 }}
      >
        <ChakraPopover.Trigger asChild>{children}</ChakraPopover.Trigger>
        <Portal disabled={!portalled} container={portalRef}>
          <ChakraPopover.Positioner>
            <ChakraPopover.Content
              width="min-content"
              p={3}
              textStyle="md"
              rounded="sm"
              ref={ref}
              {...contentProps}
            >
              {showArrow && (
                <ChakraPopover.Arrow>
                  <ChakraPopover.ArrowTip />
                </ChakraPopover.Arrow>
              )}
              {content}
            </ChakraPopover.Content>
          </ChakraPopover.Positioner>
        </Portal>
      </ChakraPopover.Root>
    );
  },
);

export type InfoTipProps = Partial<ToggleTipProps> & {
  buttonProps?: IconButtonProps | undefined;
};

const InfoTip = React.forwardRef<HTMLDivElement, InfoTipProps>(
  function InfoTip(props, ref) {
    const { children, buttonProps, ...rest } = props;

    return (
      <ToggleTip content={children} {...rest} ref={ref}>
        <IconButton variant="ghost" aria-label="info" {...buttonProps}>
          <InfoIcon color="var(--chakra-colors-link)" size={32} />
        </IconButton>
      </ToggleTip>
    );
  },
);

export default InfoTip;
